(() => {
    window.Dashboard = window.Dashboard || {}

    window.Dashboard.Models = window.Dashboard.Models || {};
    window.Dashboard.Models.Lookups = window.Dashboard.Models.Lookups || {};

    window.Dashboard.Models.Lookups.OrderStates = {
        Draft: 1,
        CreditCardPayment: 2,
        Submitted: 3,
        Created: 4,
        ContactingMediator: 5,
        PendingMediator: 6,
        MediatorSuccess: 7,
        MediatorFailure: 8,
        ContactingPrinter: 9,
        PendingStore: 10,
        PrinterSuccess: 11,
        PrinterFailure: 12,
        AtCallCentre: 13,
        CallCentreSuccess: 14,
        CallCentreFailure: 15,
        Complete: 16,
        PendingWebResponse: 17,
        WebSuccess: 18,
        WebFailure: 19,
        WaitingToSend: 20,
        PendingDeliveryProvider: 21,
        DeliveryProviderSuccess: 22,
        PendingOrderUpResponse: 23,
        OrderUpSuccess: 24,
        OrderUpFailure: 25
    };
})();
